import {platform} from '@/config.js';
import router from '@/router.js';

const topicName = topic => platform + '_' + topic;

const promisify = fn => (...args) => new Promise((resolve, reject) => fn(...args, resolve, reject));

const onReady = () => {

  promisify(FirebasePlugin.hasPermission)()
    .then(has => has
                  ? Promise.resolve()
                  : promisify(FirebasePlugin.grantPermission)()
                      .then(granted => console.log('Permissions: ' + granted))
    )
    .catch(e => console.log('Failed to grant permissions ' + JSON.stringify(e)));

  FirebasePlugin.onMessageReceived(
    message => {
      console.log('message received', JSON.stringify(message));
      if (message.tap) {
        router.push(JSON.parse(message.route));
      }
    },
    e => console.log('Failed receiving FirebasePlugin message ' + e.message)
  );
};

document.addEventListener('deviceready', onReady, false);

export const subscribe = async (topic) => {
  return promisify(FirebasePlugin.subscribe)(topicName(topic))
};

export const unsubscribe = async (topic) => {
  return promisify(FirebasePlugin.unsubscribe)(topicName(topic))
};
